/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */

Chart.Controller.helpers.easingEffects.coolrunner = t => {
  return t * t;
};
